import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { session } from '@/common/storage'

import { getUserInfo } from '@/apis/user'
import { getPayWayList } from '@/apis/jbbData/common'

Vue.use(VueRouter);
const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: () => import('@/components/login.vue'),
      meta: {
        title: '登陆'
      }
    },
    {
      path: '/tree',
      component: () => import('@/components/mayi/tree.vue'),
      meta: {
        title: '缓冲页'
      }
    },
    {
      path: '/bottom',
      component: () => import('../components/flex/bottom.vue')
    },
    {
      path: '/404',
      component: () => import('../components/common/404.vue')
    },
    {
      path: '/403',
      component: () => import('../components/common/403.vue')
    },
    // {
    //   path: '*',
    //   redirect: '/404'
    // },


    //问卷调查路由
    {
      path: '/questPage',
      component: () => import('@/components/weChatOfficial/common/questPage.vue'),
      meta: {
        title: '编辑项目'
      }
    },
    //报表分析
    {
      path: '/questReport',
      component: () => import('@/components/weChatOfficial/common/questReport.vue'),
      meta: {
        title: '报表分析'
      }
    },

    {
      path: '/weixinSuccess',
      component: () => import('@/components/common/common/work/weixinSuccess.vue'),
      meta: {
        title: '报表分析'
      }
    },
    // 数据中台
    {
      path: '/midOffice',
      component: () => import('@/components/midOffice/index.vue'),
      meta: {
        title: '数据中台'
      }
    }
  ],
  mode: 'history'
});


// const store = new Vuex.Store({
//   modules: modules,
// })

const whiteList = [ '/login', '/weixinSuccess', '/404', '/tree' ]

//全局路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.query.token) {
    let query = {
      redirect: to.path == '/login' ? '/index' : to.path,
      token: to.query.token
    }
    sessionStorage.setItem('loginToken', JSON.stringify(query))
    localStorage.removeItem('token')
  }
  if (whiteList.includes(to.path)) {
    next()
  } else {
    let token = window.localStorage.getItem('token')
    if (!token) {
      // 如果没登录,都导向登录页
      next({ path: '/login' })
    } else {
      if (!store.getters.userInfo) {
        try {
          const res = await getUserInfo()
          const data = res.content
          store.dispatch('add_userInfo', data.userInfo)
          //type 角色不存在 去除首页工作台
          var sl = data.sysMenuVoList
          if (!data.userInfo.type) {
            for (var i = 0; i < sl.length; i++) {
              if (sl[i].permission === 'index') {
                var child = sl[i].children;
                for (var y = 0; y < child.length; y++) {
                  if (child[y].permission === 'index') {
                    sl[i].children.splice(y, 1)
                  }
                }
              }
            }
          }
          //排查出 账户统计
          let uId = data.userInfo.userId
          if (!([3,312,383,384].includes(uId))) {
            for (var i = 0; i < sl.length; i++) {
              if (sl[i].id === 177) {
                var child = sl[i].children;
                for (var y = 0; y < child.length; y++) {
                  if (child[y].id === 178) {
                    sl[i].children.splice(y, 1)
                  }
                }
              }
            }
          }
          //存入菜单,渲染菜单
          store.dispatch('add_Menus', sl)
          //动态设置路由
          store.dispatch('add_Routes', sl)
          //存入权限按钮
          store.dispatch('add_Jurisdict', data.jurisdict)
          store.commit('user/SET_USERINFO', data)
          if (!store.state.data.payWay) {
            // 设置支付方式数据
            await setPayWayList()
          }
          next({ ...to, replace: true })
        } catch (error) {
          console.error(error)
          next({ path: '/login' })
        }
      } else {
        if (!store.state.data.payWay) {
          // 设置支付方式数据
          await setPayWayList()
        }
        next()
      }
    }
  }
})

async function setPayWayList() {
  try {
    const res = await getPayWayList()
    const data = res.data.map(v => {
      v.label = v.name
      v.value = v.code
      return v
    })
    store.commit('changeData', { key: 'payWay', data })
    store.commit('changeData', { key: 'payWayApply', data })
  } catch(_e) {
    // ignore
  }
}


// 记录路由历史记录
router.beforeEach((to, from, next) => {
  const { fullPath, name, meta: { title }, path } = from
  let routeHistory = session.get('history_map')
  if (routeHistory) {
    try {
      routeHistory = JSON.parse(routeHistory)
    } catch (_error) {
      routeHistory = {}
    }
  } else {
    routeHistory = {}
  }
  if (path !== '/' && path !== '/login' && path !== '/404') {
    if (routeHistory[name]) {
      delete routeHistory[name]
    }
    routeHistory[name] = { fullPath, name, title }
    const keys = Object.keys(routeHistory)
    if (keys.length > 12) {
      keys.reverse().slice(12).forEach(key => {
        delete routeHistory[key]
      })
    }
  }
  session.set('history_map', JSON.stringify(routeHistory))
  const history = Object.values(routeHistory).reverse().filter(e => e.name !== to.name).slice(0, 6)
  session.set('route_history', JSON.stringify(history))
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js